import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { getCookies } from "cookies-next";
import { config } from "../../data/config";
import { useTranslation } from 'react-i18next';
import BreadCrump from "../tools/breadcrump";
import HeaderOfPage from "../tools/headerOfPage";

interface CountryRate {
    code: string;
    name: string;
    cost: number;
}

const COUNTRIES = [
    // Europe
    { code: 'NL', name: 'Netherlands - هلند' },
    { code: 'DE', name: 'Germany - آلمان' },
    { code: 'BE', name: 'Belgium - بلژیک' },
    { code: 'FR', name: 'France - فرانسه' },
    { code: 'GB', name: 'United Kingdom - انگلستان' },
    { code: 'IT', name: 'Italy - ایتالیا' },
    { code: 'ES', name: 'Spain - اسپانیا' },
    { code: 'CH', name: 'Switzerland - سوئیس' },
    { code: 'AT', name: 'Austria - اتریش' },
    { code: 'SE', name: 'Sweden - سوئد' },
    { code: 'NO', name: 'Norway - نروژ' },
    { code: 'DK', name: 'Denmark - دانمارک' },
    { code: 'FI', name: 'Finland - فنلاند' },
    { code: 'PL', name: 'Poland - لهستان' },
    { code: 'GR', name: 'Greece - یونان' },
    { code: 'PT', name: 'Portugal - پرتغال' },
    { code: 'IE', name: 'Ireland - ایرلند' },
    { code: 'CZ', name: 'Czech Republic - جمهوری چک' },
    { code: 'HU', name: 'Hungary - مجارستان' },
    { code: 'RO', name: 'Romania - رومانی' },
    { code: 'BG', name: 'Bulgaria - بلغارستان' },
    { code: 'HR', name: 'Croatia - کرواسی' },
    { code: 'SK', name: 'Slovakia - اسلواکی' },
    { code: 'SI', name: 'Slovenia - اسلوونی' },
    { code: 'LT', name: 'Lithuania - لیتوانی' },
    { code: 'LV', name: 'Latvia - لتونی' },
    { code: 'EE', name: 'Estonia - استونی' },
    { code: 'LU', name: 'Luxembourg - لوکزامبورگ' },
    { code: 'MT', name: 'Malta - مالت' },
    { code: 'CY', name: 'Cyprus - قبرس' },
    { code: 'IS', name: 'Iceland - ایسلند' },
    { code: 'LI', name: 'Liechtenstein - لیختن‌اشتاین' },
    { code: 'MC', name: 'Monaco - موناکو' },
    { code: 'AD', name: 'Andorra - آندورا' },
    { code: 'SM', name: 'San Marino - سان مارینو' },
    { code: 'VA', name: 'Vatican City - واتیکان' },
    { code: 'BY', name: 'Belarus - بلاروس' },
    { code: 'MD', name: 'Moldova - مولداوی' },
    { code: 'RS', name: 'Serbia - صربستان' },
    { code: 'BA', name: 'Bosnia and Herzegovina - بوسنی' },
    { code: 'ME', name: 'Montenegro - مونته‌نگرو' },
    { code: 'MK', name: 'North Macedonia - مقدونیه شمالی' },
    { code: 'AL', name: 'Albania - آلبانی' },
    { code: 'XK', name: 'Kosovo - کوزوو' },
    { code: 'RU', name: 'Russia - روسیه' },
    { code: 'UA', name: 'Ukraine - اوکراین' },
    
    // Middle East
    { code: 'IR', name: 'Iran - ایران' },
    { code: 'TR', name: 'Turkey - ترکیه' },
    { code: 'IQ', name: 'Iraq - عراق' },
    { code: 'SA', name: 'Saudi Arabia - عربستان سعودی' },
    { code: 'AE', name: 'United Arab Emirates - امارات' },
    { code: 'KW', name: 'Kuwait - کویت' },
    { code: 'QA', name: 'Qatar - قطر' },
    { code: 'OM', name: 'Oman - عمان' },
    { code: 'BH', name: 'Bahrain - بحرین' },
    { code: 'JO', name: 'Jordan - اردن' },
    { code: 'LB', name: 'Lebanon - لبنان' },
    { code: 'SY', name: 'Syria - سوریه' },
    { code: 'YE', name: 'Yemen - یمن' },
    { code: 'PS', name: 'Palestine - فلسطین' },
    { code: 'IL', name: 'Israel - اسرائیل' },
    { code: 'AZ', name: 'Azerbaijan - آذربایجان' },
    { code: 'AM', name: 'Armenia - ارمنستان' },
    { code: 'GE', name: 'Georgia - گرجستان' },
    
    // North Africa
    { code: 'EG', name: 'Egypt - مصر' },
    { code: 'MA', name: 'Morocco - مراکش' },
    { code: 'DZ', name: 'Algeria - الجزایر' },
    { code: 'TN', name: 'Tunisia - تونس' },
    { code: 'LY', name: 'Libya - لیبی' },
    { code: 'SD', name: 'Sudan - سودان' },
    
    // Other regions
    { code: 'PK', name: 'Pakistan - پاکستان' },
    { code: 'AF', name: 'Afghanistan - افغانستان' },
    { code: 'US', name: 'United States - ایالات متحده' },
    { code: 'CA', name: 'Canada - کانادا' },
    { code: 'AU', name: 'Australia - استرالیا' },
    { code: 'NZ', name: 'New Zealand - نیوزیلند' },
    { code: 'IN', name: 'India - هند' },
    { code: 'CN', name: 'China - چین' },
    { code: 'JP', name: 'Japan - ژاپن' },
    { code: 'KR', name: 'South Korea - کره جنوبی' },
    { code: 'BR', name: 'Brazil - برزیل' },
    { code: 'MX', name: 'Mexico - مکزیک' },
    { code: 'AR', name: 'Argentina - آرژانتین' },
    { code: 'ZA', name: 'South Africa - آفریقای جنوبی' },
];

export default function ShippingSettingsPage() {
    const { t } = useTranslation();
    const cookie = getCookies();

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [settingsId, setSettingsId] = useState<string>('');
    const [defaultCost, setDefaultCost] = useState<number>(5);
    const [freeShippingThreshold, setFreeShippingThreshold] = useState<number>(0);
    const [countryRates, setCountryRates] = useState<CountryRate[]>([]);
    const [selectedCountry, setSelectedCountry] = useState<string>('');

    const breadcrump = [
        { name: t('Dashboard'), url: '/dashboard' },
        { name: t('Setting'), url: '/dashboard/Setting' },
        { name: t('Shipping Settings'), url: null },
    ];

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const response = await axios.get(`${config.url}/v1/dashboard/setting`, {
                headers: { Authorization: `Bearer ${cookie['token']}` }
            });
            const data = response.data?.message;
            if (data) {
                setSettingsId(data._id);
                const shipping = data.shippingSettings || {
                    defaultCost: 5,
                    freeShippingThreshold: 0,
                    countryRates: {}
                };
                setDefaultCost(shipping.defaultCost ?? 5);
                setFreeShippingThreshold(shipping.freeShippingThreshold ?? 0);

                // Convert countryRates object to array
                const rates: CountryRate[] = [];
                if (shipping.countryRates) {
                    Object.entries(shipping.countryRates).forEach(([code, cost]) => {
                        const country = COUNTRIES.find(c => c.code === code);
                        rates.push({
                            code,
                            name: country?.name || code,
                            cost: Number(cost)
                        });
                    });
                }
                setCountryRates(rates);
            }
        } catch (err) {
            console.error('Error fetching settings:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        if (!settingsId) return;
        setSaving(true);
        try {
            // Convert array back to object
            const ratesObj: Record<string, number> = {};
            countryRates.forEach(rate => {
                ratesObj[rate.code] = rate.cost;
            });

            await axios.put(`${config.url}/v1/dashboard/setting/${settingsId}`, {
                shippingSettings: {
                    defaultCost,
                    freeShippingThreshold,
                    countryRates: ratesObj
                }
            }, {
                headers: { Authorization: `Bearer ${cookie['token']}` }
            });

            Swal.fire({
                icon: 'success',
                title: t('Shipping settings saved successfully'),
                showConfirmButton: false,
                timer: 1500,
                toast: true,
                position: 'top-end',
            });
        } catch (err) {
            console.error('Error saving settings:', err);
            Swal.fire({
                icon: 'error',
                title: t('Error saving shipping settings'),
            });
        } finally {
            setSaving(false);
        }
    };

    const handleAddCountry = () => {
        if (!selectedCountry) return;
        // Check if already exists
        if (countryRates.find(r => r.code === selectedCountry)) {
            Swal.fire({ icon: 'warning', title: t('This country already has a custom rate') });
            return;
        }
        const country = COUNTRIES.find(c => c.code === selectedCountry);
        setCountryRates(prev => [...prev, {
            code: selectedCountry,
            name: country?.name || selectedCountry,
            cost: defaultCost
        }]);
        setSelectedCountry('');
    };

    const handleRemoveCountry = (code: string) => {
        setCountryRates(prev => prev.filter(r => r.code !== code));
    };

    const handleRateChange = (code: string, cost: number) => {
        setCountryRates(prev => prev.map(r => r.code === code ? { ...r, cost } : r));
    };

    // Filter out countries that already have rates
    const availableCountries = COUNTRIES.filter(
        c => !countryRates.find(r => r.code === c.code)
    );

    if (loading) {
        return (
            <div className="bg-white p-3 m-4 h-[100vh]">
                <BreadCrump data={breadcrump} />
                <div className="flex items-center justify-center py-20">
                    <span className="text-gray-500">{t('Loading...')}</span>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-white p-3 m-4 min-h-[100vh]">
            <BreadCrump data={breadcrump} />
            <HeaderOfPage title={t("Shipping Settings")} description={t("Manage shipping costs per country")} />

            <div className="max-w-3xl mx-auto mt-6 space-y-8">
                {/* Default Settings */}
                <div className="border border-gray-200 rounded-xl p-6 space-y-4">
                    <h3 className="text-lg font-bold text-gray-800">{t("Default Settings")}</h3>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-600 mb-1">
                                {t("Default Shipping Cost")}
                            </label>
                            <input
                                type="number"
                                min="0"
                                step="0.01"
                                value={defaultCost}
                                onChange={(e) => setDefaultCost(Number(e.target.value))}
                                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                            />
                            <p className="text-xs text-gray-400 mt-1">
                                {t("Applied to all countries without a custom rate")}
                            </p>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-600 mb-1">
                                {t("Free Shipping Threshold")}
                            </label>
                            <input
                                type="number"
                                min="0"
                                step="0.01"
                                value={freeShippingThreshold}
                                onChange={(e) => setFreeShippingThreshold(Number(e.target.value))}
                                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                            />
                            <p className="text-xs text-gray-400 mt-1">
                                {t("Orders above this amount get free shipping")}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Country Rates */}
                <div className="border border-gray-200 rounded-xl p-6 space-y-4">
                    <h3 className="text-lg font-bold text-gray-800">{t("Country-Specific Rates")}</h3>

                    {/* Add Country */}
                    <div className="flex gap-2">
                        <select
                            value={selectedCountry}
                            onChange={(e) => setSelectedCountry(e.target.value)}
                            className="flex-1 px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                        >
                            <option value="">{t("Select a country to add")}</option>
                            {availableCountries.map(c => (
                                <option key={c.code} value={c.code}>{c.name} ({c.code})</option>
                            ))}
                        </select>
                        <button
                            onClick={handleAddCountry}
                            disabled={!selectedCountry}
                            className="px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                        >
                            {t("Add")}
                        </button>
                    </div>

                    {/* Rates List */}
                    {countryRates.length === 0 ? (
                        <div className="py-8 text-center text-gray-400">
                            {t("No custom country rates")} (€{defaultCost})
                        </div>
                    ) : (
                        <div className="space-y-2">
                            <div className="grid grid-cols-12 gap-2 text-sm font-medium text-gray-500 px-2">
                                <div className="col-span-2">{t("Code")}</div>
                                <div className="col-span-5">{t("Country")}</div>
                                <div className="col-span-3">{t("Cost")}</div>
                                <div className="col-span-2"></div>
                            </div>
                            {countryRates.map(rate => (
                                <div
                                    key={rate.code}
                                    className="grid grid-cols-12 gap-2 items-center bg-gray-50 rounded-xl px-3 py-2"
                                >
                                    <div className="col-span-2 font-mono text-sm font-bold">{rate.code}</div>
                                    <div className="col-span-5 text-sm">{rate.name}</div>
                                    <div className="col-span-3">
                                        <input
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            value={rate.cost}
                                            onChange={(e) => handleRateChange(rate.code, Number(e.target.value))}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                                        />
                                    </div>
                                    <div className="col-span-2 text-right">
                                        <button
                                            onClick={() => handleRemoveCountry(rate.code)}
                                            className="text-red-500 hover:text-red-700 text-sm transition-colors"
                                        >
                                            {t("Remove")}
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Save Button */}
                <div className="flex justify-end pb-8">
                    <button
                        onClick={handleSave}
                        disabled={saving}
                        className="px-8 py-3 bg-green-600 text-white rounded-xl hover:bg-green-700 disabled:opacity-50 transition-colors font-medium text-lg"
                    >
                        {saving ? t('Saving...') : t('Save Settings')}
                    </button>
                </div>
            </div>
        </div>
    );
}
